<template>
  <section id="assist__user">
    <div class="bgd" />
    <div class="img" :style="$bgd(data.gravatar)" />
    <p>{{ data.name }}</p>
    <p @click="$emit('hint')" class="btn-hint">
      <i class="anyteachicon anyteach-ArtboardCopy" />分享本页面
    </p>
  </section>
</template>

<script>
export default {
  name: "AssistUser",
  props: ["data"],
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__user {
  text-align: center;
  position: relative;
  padding-top: 0;
  .bgd {
    height: 60px;
    background: $purple;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;
  }
  .img {
    position: relative;
    z-index: 1;
    $size: 120px;
    width: $size;
    height: $size;
    border-radius: 50%;
    border: 3px solid white;
    display: inline-block;
  }
  p {
    font-size: 0.9rem;
    @include avenir-demi();
  }
  .btn-hint {
    font-weight: 500;
    i {
      margin-right: 3px;
      font-size: inherit;
    }
  }
}
</style>
